// Template265: Pekín - Día 1 mapa (Dia1MapaPekin.jsx)
// Sin hero: cabecera, intro, 4 bloques (Beihai, Qianmen, Hutongs, Templo del Cielo), SabiasQue, caja Cómo llegar.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template265 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const title1 = page?.texts?.[2]?.content;
	const body1 = page?.texts?.[3]?.content;
	const title2 = page?.texts?.[4]?.content;
	const body2 = page?.texts?.[5]?.content;
	const title3 = page?.texts?.[6]?.content;
	const body3 = page?.texts?.[7]?.content;
	const title4 = page?.texts?.[8]?.content;
	const body4 = page?.texts?.[9]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const img1 = getImageSrc("img1");
	const img2 = getImageSrc("img2");
	const sticker3 = getImageSrc("sticker3");
	const img4 = getImageSrc("img4");
	const sticker4 = getImageSrc("sticker4");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const tipBlock4 = page?.data?.tipBlock4;
	const comoLlegar = page?.data?.comoLlegar;
	const actualHeaderColor = headerBackgroundColor || "#8c1d18";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 9999,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px", position: "relative" }}>
				{intro && (
					<Box component="p" sx={{ ...estiloP, marginBottom: 1 }}>
						{intro}
					</Box>
				)}

				<Box
					data-block-id="text-2"
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1.5,
						marginTop: 1.25,
					}}
				>
					{/* Block 1: Beihai */}
					{title1 && (
						<Box data-block-id="text-3" sx={{ display: "flex", gap: 2, position: "relative" }}>
							{img1 && (
								<Box
									component="img"
									src={img1}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							<Box sx={{ width: img1 ? "60%" : "100%" }}>
								<Box component="h3" sx={estiloH3}>
									{title1}
								</Box>
								{body1 && (
									<Box component="p" sx={estiloP}>
										{body1}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Block 2: Qianmen */}
					{title2 && (
						<Box data-block-id="text-4" sx={{ display: "flex", gap: 2, position: "relative" }}>
							{sabiasQue[0] && (
								<Box sx={{ position: "absolute", top: 0, left: "34%" }}>
									<SabiasQue
										icono={sabiasQue[0].icono}
										texto={sabiasQue[0].texto}
									/>
								</Box>
							)}
							{sabiasQue[1] && (
								<Box sx={{ position: "absolute", top: 40, left: "34%" }}>
									<SabiasQue
										icono={sabiasQue[1].icono}
										texto={sabiasQue[1].texto}
									/>
								</Box>
							)}
							{img2 && (
								<Box
									component="img"
									src={img2}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							<Box sx={{ width: img2 ? "60%" : "100%" }}>
								<Box component="h3" sx={estiloH3}>
									{title2}
								</Box>
								{body2 && (
									<Box component="p" sx={estiloP}>
										{body2}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Block 3: Hutongs - caja rosa, sticker */}
					{title3 && (
						<Box data-block-id="text-5" sx={{ display: "flex", gap: 2, position: "relative" }}>
							<Box sx={{ width: "100%" }}>
								<Box
									sx={{
										...estiloP,
										padding: 1.5,
										backgroundColor: "#fde1e0",
										borderRadius: "12px",
										position: "relative",
									}}
								>
									{sticker3 && (
										<Box
											component="img"
											src={sticker3}
											alt=""
											sx={{
												width: 105,
												position: "absolute",
												bottom: isSmallScreen ? 120 : 80,
												left: -40,
											}}
										/>
									)}
									<Box component="h3" sx={estiloH3}>
										{title3}
									</Box>
									{body3 && <Box component="span">{body3}</Box>}
								</Box>
							</Box>
						</Box>
					)}

					{/* Block 4: Templo del Cielo */}
					{title4 && (
						<Box data-block-id="text-6" sx={{ display: "flex", gap: 2, position: "relative" }}>
							{img4 && (
								<Box
									component="img"
									src={img4}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							{sabiasQue[2] && (
								<Box sx={{ position: "absolute", top: -10, left: "32%" }}>
									<SabiasQue
										icono={sabiasQue[2].icono}
										texto={sabiasQue[2].texto}
									/>
								</Box>
							)}
							{tipBlock4 && (
								<Box
									sx={{
										position: "absolute",
										bottom: isSmallScreen ? -80 : -30,
										right: 50,
										backgroundColor: "#fff8db",
										border: "2px solid #f5c400",
										borderRadius: "16px 16px 0px 16px",
										padding: "10px 12px",
										fontSize: 11,
										color: "#444",
										boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
										maxWidth: isSmallScreen ? 260 : 340,
										zIndex: 3,
									}}
								>
									{tipBlock4}
								</Box>
							)}
							{sticker4 && (
								<Box
									component="img"
									src={sticker4}
									alt=""
									sx={{
										width: 105,
										position: "absolute",
										bottom: isSmallScreen ? -100 : -55,
										right: -40,
									}}
								/>
							)}
							<Box sx={{ width: img4 ? "60%" : "100%" }}>
								<Box component="h3" sx={estiloH3}>
									{title4}
								</Box>
								{body4 && (
									<Box component="p" sx={estiloP}>
										{body4}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Cómo llegar */}
					{comoLlegar && (
						<Box
							data-block-id="text-7"
							sx={{
								backgroundColor: "#fde1e0",
								border: "3px solid",
								borderColor: actualHeaderColor,
								borderRadius: "12px",
								padding: "8px 20px",
								fontSize: 13,
								color: "#333",
								marginBottom: isSmallScreen ? 1.5 : 0,
								marginTop: isSmallScreen ? 8 : 3,
							}}
						>
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: 13,
									fontWeight: 700,
									color: actualHeaderColor,
									textTransform: "uppercase",
								}}
							>
								Cómo llegar
							</Box>
							<Box
								component="ul"
								sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.6 }}
								dangerouslySetInnerHTML={{ __html: comoLlegar }}
							/>
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template265.thumbnail = "/images/template-1.png";
export default Template265;
